import { FC } from 'react'
import cn from 'classnames'
import styles from './Title.module.scss'

interface TitleProps {
  className?: string
  title: string
}
export const Title: FC<TitleProps> = ({ className, title }) => {
  return <h1 className={cn(styles.container, className)}>{title}</h1>
}
